import React, { useRef } from 'react';

interface MapResizeHandleProps {
    // Called with the horizontal mouse movement (in pixels) while dragging
    onResize: (deltaX: number) => void;
}

const MapResizeHandle: React.FC<MapResizeHandleProps> = ({ onResize }) => {
    const lastX = useRef<number | null>(null);

    // Start tracking the drag on mouse down
    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        lastX.current = e.clientX;

        // Report the horizontal movement while dragging
        const handleMouseMove = (moveEvent: MouseEvent) => {
            if (lastX.current === null) return;
            const deltaX = moveEvent.clientX - lastX.current;
            lastX.current = moveEvent.clientX;
            onResize(deltaX);
        };

        // Stop tracking the drag on mouse up
        const handleMouseUp = () => {
            lastX.current = null;
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    };

    return <div className="scheduling-side-panel-resize-handle" onMouseDown={handleMouseDown} />;
};

export default MapResizeHandle;
